/**
 * Tracking metadata merged into the public submission payload (v1 parity).
 *
 * @param {{ conf?: object }} ctx
 * @returns {Record<string, string>}
 */
export function buildLeadFormTrackingMetadata(ctx = {}) {
  const conf = ctx.conf || {}
  const sessionId =
    conf.sessionId || conf.userId || conf.user_id || ''
  return {
    submission_date: new Date().toLocaleString(),
    page_url: typeof window !== 'undefined' ? window.location.href : '',
    user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : '',
    user_id: sessionId ? String(sessionId) : '',
  }
}

/**
 * Default POST for overlay lead forms when the host does not pass onSubmitForm.
 * Public widget route (no master key required for submissions).
 *
 * @param {{ form: object, data: Record<string, unknown>, conf?: object }} payload
 * @param {{ apiBaseUrl?: string, conf?: object }} ctx
 */
export async function submitWidgetLeadFormDefault(payload, ctx) {
  const conf = payload.conf || ctx.conf || {}
  const base = String(ctx.apiBaseUrl || conf.apiBaseUrl || '').replace(/\/$/, '')
  const formId = payload.form?.id
  if (!base || formId == null || formId === '') {
    return
  }

  const tracking = buildLeadFormTrackingMetadata({ conf })
  const data = { ...(payload.data || {}), ...tracking }

  const url = `${base}/api/v1/widget/lead-forms/${encodeURIComponent(String(formId))}/submissions`
  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
    credentials: 'omit',
    body: JSON.stringify(data),
  })

  if (!res.ok) {
    const text = await res.text().catch(() => '')
    throw new Error(
      `Lead form submit failed (${res.status}): ${text || res.statusText || 'Unknown error'}`,
    )
  }
}
